import React, { useContext, useEffect, useRef, useState } from 'react';
import {ethers} from 'ethers';
import './Home.css';
import { toast } from 'react-toast';
import Web3Ctx from '../Context/Web3Ctx';
import { getContract, getDummy721 } from '../Utils/GetContract';
import config from '../../config'
import Navigation from '../Navigation/Navigation';
import coin from '../../assets/images/COIN-BIG-SILVER.png';
import CounterBar from '../common/CounterBar';
import BgAnim from '../common/BgAnim';
import { Zoom } from "zoom-next";
import useInterval from "../common/useInterval";
import {pools} from '../common/DustPools';



const Home = (props) => {

    const PUNK_VAULT_ID = 0; //punks vault id
    const UPDATE_INTERVAL = 60000; 

    const {onboard,ethersProvider,address} = useContext(Web3Ctx);

    const [dustContract,setDustContract] = useState(null);
    const [dust4PunksContract,setDust4PunksContract] = useState(null);
    const [zoom2,setZoom2] = useState(null);

    const [allPools, setAllPools] = useState(pools);

    const [orderedPools, setOrderedPools] = useState(null);


    const [dustBalance,setDustBalance] = useState(null);
    
    const [vaultData,setVaultData] = useState({
        vaultAddress: null,
        vaultName: null,
        vaultPrice: null,
        vaultToken: null,
        totalSupply:null,
        available:null
       });

    const [vaultsData,setVaultsData]=useState([]);

    const [vaultTokenContract, setVaultTokenContract] = useState(null);

    const [initDone, setInitDone] = useState(false);



    useEffect(()=>{

        const initContract = async ()=>{
            let c = await getContract('Dust',ethersProvider);
            if(c){
                setDustContract(c);
            }else{
                toast.error('contract not found');
            }

            let Zoom2Contract = await getContract('Zoom2', ethersProvider);
            if (Zoom2Contract) {
                setZoom2(Zoom2Contract);
            } else {
                toast.error('Could not initialise Zoom2 Contract');
            }

            let D4P = await getContract('Dust4Punks', ethersProvider);
            if (D4P) {
                setDust4PunksContract(D4P);
            } else {
                toast.error('Could not initialise D4P Contract');
            }
        }

        if(ethersProvider){
            initContract();
        }
    },[ethersProvider]);

    useEffect(()=>{
        const getData = async()=>{
           // if(address){
                const ZoomLibraryInstance = new Zoom({ use_reference_calls: true });
                let calls = [];


                for(let i = 0; i<allPools.length;i++){

                    //Punk vault address
                    const vaultAddress = ZoomLibraryInstance.addCall(
                        dust4PunksContract,
                        ["vaultAddress", [i]],
                        "vaultAddress(uint256) returns (address)"
                    );
                    calls.push(vaultAddress);

                    //Pool Name
                    const vaultName = ZoomLibraryInstance.addCall(
                        dust4PunksContract,
                        ["vaultName", [i]],
                        "vaultName(uint256) returns (string)"
                    );
                    calls.push(vaultName);

                    //Vault price
                    const vaultPrice = ZoomLibraryInstance.addCall(
                        dust4PunksContract,
                        ["vaultPrice", [i]],
                        "vaultPrice(uint256) returns (uint256)"
                    );
                    calls.push(vaultPrice);

                    //Vault token addredd
                    const vaultToken = ZoomLibraryInstance.addCall(
                        dust4PunksContract,
                        ["vaultToken", [i]],
                        "vaultToken(uint256) returns (address)"
                    );
                    calls.push(vaultToken);
                }

                const ZoomQueryBinary = ZoomLibraryInstance.getZoomCall();

                //console.log("======== ZOOM CALL START ============" );
                //console.time('zoomCall');
                const combinedResult = await zoom2.combine( ZoomQueryBinary );
                //console.timeEnd('zoomCall');
                //console.log("======== ZOOM CALL END ==============" );
    
                ZoomLibraryInstance.resultsToCache( combinedResult, ZoomQueryBinary);

                //4 calls per vault

                let ap = allPools;
                let poolIdx=0;
                for(let i=0;i<allPools.length*4; i+=4){
                    let va = ZoomLibraryInstance.decodeCall(calls[i+0]).toString();
                    let vn = ZoomLibraryInstance.decodeCall(calls[i+1]).toString();
                    let vp = ZoomLibraryInstance.decodeCall(calls[i+2]).toString();
                    let vt = ZoomLibraryInstance.decodeCall(calls[i+3]).toString();

                    
                    const vd = {
                        vaultAddress: va,
                        vaultName: vn,
                        vaultPrice: vp,
                        vaultToken: vt,
                        available: null,
                        totalSupply: null
                    };

                    let vToken = await getDummy721(vt,ethersProvider);
                    
                    if(vToken){
                        vd.tokenContract = vToken;
                    }

                    ap[poolIdx].vaultData = vd;
                    poolIdx++;
                }
                setAllPools([...ap]);


                console.log('AP',ap);
                setInitDone(true);
        }

        if(dustContract && zoom2 && dust4PunksContract && !initDone){
           // console.log('getting balance');
            getData();
        }

    },[dustContract,zoom2,dust4PunksContract]);

    useEffect(()=>{
        if(initDone){
            updateVaultBalances();
        }
    },[initDone]);

    useInterval(()=>{
        updateVaultBalances();
    },UPDATE_INTERVAL);


    const updateVaultBalances = async ()=>{
        if(allPools[0].vaultData && allPools[0].vaultData.tokenContract){
            //console.log('vaultdata',vaultData);

            const ZoomLibraryInstance = new Zoom();
            let calls = [];


            let hasContract = [];

           // console.log('UPD',pools,allPools);

            for(let i=0;i<allPools.length;i++){
                if(allPools[i].vaultData.tokenContract.address!=="0x0000000000000000000000000000000000000000"){

                  //  console.log(allPools[i].vaultData.tokenContract,i)
/* 
                    const totalSupply = ZoomLibraryInstance.addCall(
                        allPools[i].vaultData.tokenContract,
                        ["totalSupply",[]],
                        "totalSupply() returns (uint256)"
                    );
                    calls.push(totalSupply); */
        
                    const vaultBalance = ZoomLibraryInstance.addCall(
                        allPools[i].vaultData.tokenContract,
                        ["balanceOf",[ allPools[i].vaultData.vaultAddress]],
                        "balanceOf(address) returns (uint256)"
                    );
                    calls.push(vaultBalance);
                    hasContract.push(allPools[i].id);
                }
            }

            if(calls.length>0){

    
                const ZoomQueryBinary = ZoomLibraryInstance.getZoomCall();

               // console.log('zqb',ZoomQueryBinary);
    
                //console.log("======== ZOOM CALL START ============" );
                //console.time('zoomCall');
                const combinedResult = await zoom2.combine( ZoomQueryBinary );
                //console.timeEnd('zoomCall');
                //console.log("======== ZOOM CALL END ==============" );
    
                ZoomLibraryInstance.resultsToCache( combinedResult, ZoomQueryBinary );
    

                let ap = allPools;
                let hasContractIdx = 0;
                for(let i=0;i<calls.length;i++){
                   // let ts = ZoomLibraryInstance.decodeCall(calls[i]).toString();
                    let ab = ZoomLibraryInstance.decodeCall(calls[i]).toString();
                    let poolIdx = hasContract[hasContractIdx];
                    ap[poolIdx].vaultData = {...ap[poolIdx].vaultData,/* totalSupply:ts, */ available:ab}
                    if(Number.parseInt(ab)===0){
                        ap[poolIdx].order+=100;
                    }
                    hasContractIdx++;
                }

                let op = [...ap];

                op.sort((a,b)=>{
                    if(a.order>b.order){
                        return 1
                    }else{
                        return -1;
                    }
                });

                setAllPools([...ap]);
                setOrderedPools(op);

                console.log("AP upd", ap,op);


            }


        }
    }





    const handleConnect = async () => {
        if (onboard) {
            onboard.walletReset();
            const selected = await onboard.walletSelect().catch((e)=>{console.log(e)});
            if(selected){
               await  onboard.walletCheck();
            }
        }
    }

    const goToExchange = (idx)=>{

        props.history.push({
            pathname: '/exchange/'+idx
        });
    }


    return (
        <>
            <div className="header-box">
                <Navigation/>

                <div className="header-content">
                        <h1 className="title">THE DUST</h1>
                        <h1 className="title">TOKEN</h1>
                        <p className="">Dust is Ether Card’s utility token that will be used across the entire Ether Cards ecosystem.</p>
                        <img className="coin" src={coin} />
                </div>                              
            </div>

            <div className="container mt-5 h-100 home">

                <div className="row">
                    <div className="col-md-8 text-center mx-auto">
                        <h1 className="title-black">THE POOLS</h1>
                        <p className="mt-5 mx-auto">You can exchange your Dust for some awesome items including CryptoPunks and other valuable NFTs.</p>
                    </div>
                </div>

                <div className="row mt-5 justify-content-between flex-wrap">
                    

                    {(orderedPools && initDone) &&
                    
                    <>
                        {orderedPools.map((pool,idx)=>{return(
                            <div key={'pool'+idx} className="col-md-6">
                                <div className="pool-box">
                                    <div className="box-content">
                                        <div className={`image-container ${pool.type}`} ></div>

                                        <div className="info-container d-flex flex-column">
                                            <h4 className="pool-title mb-0">{pool.poolName}</h4>

                                            <p className="labels mb-0">Counter:</p>
                                            <CounterBar value={pool.vaultData.available} maxValue={pool.totalSupply} />
                                    
                                            <p className="labels mb-0">Price:</p>
                                            <p className="mt-0">{pool.vaultData.vaultPrice>0?Number(ethers.utils.formatEther(pool.vaultData.vaultPrice)).toLocaleString()+' D':'TBA'}</p>
                                            {address?
                                            <button className={`btn btn-pool  outline  mr-auto mt-auto ${(pool.vaultData.available===null||Number(pool.vaultData.available)===0)?'disabled':''}`} disabled={(pool.vaultData.available===null||Number(pool.vaultData.available)===0)} onClick={()=>goToExchange(pool.id)}>exchange</button>
                                            :
                                            <button className={`btn btn-pool  outline  mr-auto mt-auto ${(pool.vaultData.available===null||Number(pool.vaultData.available)===0)?'disabled':''}`} disabled={(pool.vaultData.available===null||Number(pool.vaultData.available)===0)} onClick={()=>handleConnect()}>connect to wallet</button>
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        )})}
                    </>}

                </div>


                <div className="row mt-5">
                    <div className="col-md-6 text-center mx-auto">
                        <h3 className="">Don’t miss any updates about the dust pools!</h3>
                    </div>
                </div>


                <div className="row mt-3">
                    <div className="col-md-6 text-center mx-auto hexa-container">
                        <div className="hexa a-right">
                            <h4 className="title">FOLLLOW US<br/>ON TWITTER</h4>
                            <a className="hex-image" href="https://twitter.com/ether_cards" target="_blank" rel="noreferrer">
                                <span className="twitter"></span>
                            </a>
                        </div>
                       
                        <div className="hexa a-left">
                            <h4 className="title">JOIN OUR<br/>DISCORD</h4>
                            <a className="hex-image" href="https://discord.com/invite/mBwauRSJNW" target="_blank" rel="noreferrer">
                                <span className="discord"></span>
                            </a>
                        </div>

                        <div className="hexa a-right">
                            <h4 className="title"></h4>
                            <a className="hex-image">
                                <span className="dust"></span>
                            </a>
                        </div>
                    </div>
                </div>






                <div className="row mt-5 pb-5">
                    <div className="col-md-7 small-text text-center mx-auto text-halfbright">
                        <p className="mt-5 mx-auto">Ether Cards makes no representation, warranty, or undertaking, express or implied, as to the accuracy, reliability, completeness, or reasonableness of the information in this roadmap. Any assumptions, opinions, and details expressed in any Ether Cards blog or community posts constitute Ether Card’s judgment as of the date thereof and are subject to change without notice. Any projections or claims contained in the information are based on a number of assumptions including, but not limited to market conditions and the current status of Ether Cards, and there can be no guarantee that any projected outcomes will be achieved.</p>
                    </div>
                </div>

            </div>
            <BgAnim/>                    
        </>
    );

}

export default Home;